import React from 'react';
import { FaStar, FaStarHalfAlt, FaRegStar } from 'react-icons/fa';
import { FiExternalLink } from 'react-icons/fi';
import "./Card.css";

const StarRating = ({ rating }) => {
  if (rating === null || rating === undefined) return null;
  const stars = [];
  const fullStars = Math.floor(rating);
  const hasHalf = rating % 1 >= 0.3 && rating % 1 <= 0.7;
  const emptyStars = 5 - fullStars - (hasHalf ? 1 : 0);

  for (let i = 0; i < fullStars; i++) {
    stars.push(<FaStar key={`full-${i}`} className="star star--filled" />);
  }
  if (hasHalf) {
    stars.push(<FaStarHalfAlt key="half" className="star star--filled" />);
  }
  for (let i = 0; i < emptyStars; i++) {
    stars.push(<FaRegStar key={`empty-${i}`} className="star star--empty" />);
  }

  return (
    <div className="card__rating">
      <div className="card__stars">{stars}</div>
      <span className="card__rating-value">{rating.toFixed(1)}</span>
    </div>
  );
};

const getCategoryColor = (category) => {
  const colors = {
    Apps: '#8750f7',
    Web: '#33c648',
    Community: '#f59e0b',
  };
  return colors[category] || '#8750f7';
};

const Card = (props) => {
  const categoryColor = getCategoryColor(props.category);

  return (
    <div className="card">
      <div className="card__image-wrapper">
        <div className="card__image-glow" style={{ background: categoryColor }}></div>
        <img src={props.image} alt={props.title} className="card__image" />
        <span className="card__badge" style={{ background: categoryColor }}>
          {props.category}
        </span>
      </div>

      <div className="card__body">
        <h3 className="card__title">{props.title}</h3>
        <StarRating rating={props.rating} />
        <p className="card__desc text__muted">{props.data.description}</p>
        <a
          href={props.demoLink}
          target="_blank"
          rel="noreferrer"
          className="btn btn__primary card__cta"
        >
          View Project <FiExternalLink />
        </a>
      </div>
    </div>
  );
}

export default Card;
